export default __webpack_public_path__ + "static/media/aea_tribe.d45985d2.webp";